import { render } from "./AiInsuringDashboard.vue?vue&type=template&id=502124e5&scoped=true"
import script from "./AiInsuringDashboard.vue?vue&type=script&lang=js"
export * from "./AiInsuringDashboard.vue?vue&type=script&lang=js"

import "./AiInsuringDashboard.vue?vue&type=style&index=0&id=502124e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502124e5"]])

export default __exports__